import StartPageWrapper from '../../components/Views/StartPageWrapper'
import { AvailabilityWrapper } from './AvailabilityWrapper'
import { BedPageWrapper } from './BedPageWrapper'
import { BookingIntegrationPageWrapper } from './BookingIntegrationPageWrapper'
import { BookingAppPageWrapper } from './BookingAppPageWrapper'
import { BookingPageWrapper } from './BookingPageWrapper'
import { ChangeRoomsWrapper } from './ChangeRoomsWrapper'
import { CheckInAutoPageWrapper } from './CheckInAutoPageWrapper'
import { CheckInPageWrapper } from './CheckInListPageWrapper'
import { CheckInParkingPageWrapper } from './CheckInParkingPageWrapper'
import { CheckOutListPageWrapper } from './CheckOutListPageWrapper'
import { CheckinAppPageWrapper } from './CheckinAppPageWrapper'
import { CheckingPageWrapper } from './CheckingPageWrapper'
import { CheckoutAppPageWrapper } from './CheckoutAppPageWrapper'
import { CheckoutPageWrapper } from './CheckoutPageWrapper'
import { ControlStatusPageWrapper } from './ControlStatusPageWrapper'
import { GuestListWrapper } from './GuestListWrapper'
import { GuestPageWrapper } from './GuestPageWrapper'
import { HostingHistoryWrapper } from './HostingHistoryWrapper'
import { ModulePageWrapper } from './ModulePageWrapper'
import { OccupancyPageWrapper } from './OccupancyPageWrapper'
import { RatioCheckinoutPageWrapper } from './RatioCheckinoutPageWrapper'
import { RatioOccupancyPagewrapper } from './RatioOccupancyPageWrapper'
import { RatioRoomingListPageWrapper } from './RatioRoomingListPageWrapper'
import { RatioSalesDetailPageWrapper } from './RatioSalesDetailPageWrapper'
import { RatioSalesSummaryPageWrapper } from './RatioSalesSummaryPageWrapper'
import { ReportPageWrapper } from './ReportPageWrapper'
import { ReportSubPageWrapper } from './ReportSubPageWrapper'
import { RoomPageWrapper } from './RoomPageWrapper'
import { TyCPageWrapper } from './TyCPageWrapper'
import { RatioAvailabilityPageWrapper } from './RatioAvailabilityPageWrapper'
import { RatioSummaryStayPageWrapper } from './RatioSummaryStayPageWrapper'
import { CancellationsChangesPageWrapper } from './CancellationsChangesPageWrapper'
import { ReportOccupancyPageWrapper } from './ReportOccupancyPageWrapper'
import { ReportValorationPageWrapper } from './ReportValorationPageWrapper'
import { CheckInAutoAutoPageWrapper } from './CheckInAutoAutoPageWrapper'
import { BookingFaceToFacePageWrapper } from './BookisFaceToFacePageWrapper'
import { RetiredGuestsPageWrapper } from './RetiredGuestsPageWrapper'
import { ReportCamasPreferentesPageWrapper } from './ReportCamasPreferentesPageWrapper'
export const ListWrappers = {
  modules: <ModulePageWrapper />,
  rooms: <RoomPageWrapper />,
  beds: <BedPageWrapper />,
  guests: <GuestPageWrapper />,
  bookings: <BookingPageWrapper />,
  'booking-integration': <BookingIntegrationPageWrapper />,
  checking: <CheckingPageWrapper />,
  checkout: <CheckoutPageWrapper />,
  checkInList: <CheckInPageWrapper />,
  checkOutList: <CheckOutListPageWrapper />,
  availability: <AvailabilityWrapper />,
  start: <StartPageWrapper />,
  'change-rooms': <ChangeRoomsWrapper />,
  occupancy: <OccupancyPageWrapper />,
  guestList: <GuestListWrapper />,
  hostingHistory: <HostingHistoryWrapper />,
  reportes: <ReportPageWrapper />,
  'checkin-autoservicio': <CheckInAutoPageWrapper />,
  'checkin-autoservicio-automatico': <CheckInAutoAutoPageWrapper />,
  'checkin-parqueo': <CheckInParkingPageWrapper />,
  'reportes-sub': <ReportSubPageWrapper />,
  tyc: <TyCPageWrapper />,
  'control-status': <ControlStatusPageWrapper />,
  'reservas-app-huesped': <BookingAppPageWrapper />,
  'checkin-app-huesped': <CheckinAppPageWrapper />,
  'checkout-app-huesped': <CheckoutAppPageWrapper />,
  'reportes-ratios-checkin-checkout': <RatioCheckinoutPageWrapper />,
  'reportes-ratios-rooming-list': <RatioRoomingListPageWrapper />,
  'reportes-ratios-resumen-ventas': <RatioSalesSummaryPageWrapper />,
  'reportes-ratios-detalle-ventas': <RatioSalesDetailPageWrapper />,
  'reportes-ratios-ocupabilidad': <RatioOccupancyPagewrapper />,
  'reportes-valoration': <ReportValorationPageWrapper />,
  'reportes-ratios-disponibilidad': <RatioAvailabilityPageWrapper />,
  'reportes-ratios-estadia': <RatioSummaryStayPageWrapper />,
  'reportes-ocupabilidad': <ReportOccupancyPageWrapper />,
  'anulaciones-cambios': <CancellationsChangesPageWrapper />,
  'booking-face-to-face': <BookingFaceToFacePageWrapper />,
  'retired-guests': <RetiredGuestsPageWrapper />,
  'reportes-camas-preferentes': <ReportCamasPreferentesPageWrapper />,
  '': <></>,
} as any

export const renderPageWrapper = (key: string | undefined) => {
  let component = <></>
  if (key) {
    component = ListWrappers[key]
  }
  return component
}
